






import { Vue, Component } from 'vue-property-decorator';
import { focusTabName, orderListTypes } from '@/const/order.ts';
import SearchForm from '@/components/shipping/order/SearchForm.vue';

@Component({
  components: {
    SearchForm,
  },
})
export default class OrderPayFail extends Vue {
  private orderListTypes = orderListTypes.PAY_FAIL;
  private orderSearchTypes = focusTabName.ORDER_TAB;
}
